<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Add CashIn Method</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="country"
          method="post"
          :action="url"
          @submitted="$emit('added', $event)"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <custom-select
                  name="transaction_method_id"
                  :items="cashInMethods"
                  item-text="name"
                  item-value="id"
                  label="Payment Methods"
                />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon>mdi-plus</v-icon>
                  Add Payment Method
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    country_id: { required: true, type: [String, Number] },
  },
  data() {
    return {
      country: {},
      cashInMethods: [],
    };
  },
  mounted() {
    this.loadCashInMethods();
  },
  computed: {
    url() {
      return `api/v1/transactions/transferCountries/${this.country_id}/cashInMethods`;
    },
  },
  methods: {
    loadCashInMethods() {
      this.$http
        .get("/api/v1/transactions/transferCashInMethods")
        .then(({ data }) => (this.cashInMethods = data));
    },
  },
};
</script>
